import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/userContext';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import { Autocomplete, Checkbox, Button, Box, Chip, alpha, Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ModernTable, { ModernPageHeader } from '../components/ModernTable';
import ComputerIcon from '@mui/icons-material/Computer';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getAllMachinesURL = `/machines/getSuperAdminMC/`;
const getAllEmployeesURL = `/users/getAllEmployees`;

export default function ViewAllMachines(props) {
  const theme = useTheme();

  function bytesToMegabytes(bytes) {
    return bytes / (1024 * 1024);
  }
  const user = JSON.parse(localStorage.getItem('user'));
  const isSuperAdmin = user.role === 'SuperAdmin' ? true : false;
  const [employees, setEmployees] = useState([]);
  const [targetV, setTargetV] = useState('');
  const [users, setUsers] = useState([]);

  const [isloading, setIsLoading] = useState(false);

  const [reFresh, setRefresh] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [machine, setMachine] = useState(null);
  const [client, setClient] = useState(null);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_allMachine')
      ? localStorage.getItem('table_view_allMachine')
      : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_allMachine', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      if (isSuperAdmin) {
        await request({
          method: 'get',
          url: getAllEmployeesURL,
        }).then((res) => {
          if (!isCancelled) {
            console.log('userusers', res.data);
            setUsers(res.data);
            setIsLoading(true);
            console.log(res.data);
          }
        });
      }
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllMachines() {
      await request({
        method: 'get',
        url: getAllMachinesURL + process.env.REACT_APP_ENV1,
      }).then((res) => {
        if (!isCancelled) {
          console.log('allmachine', res.data);
          res.data?.forEach((element) => {
            if (element?.status_info === 'Out Of Service') {
              element.oos = 'NO';
            }
            if (element?.appStatus === 'false') {
              element.background = 'In Background';
            }
            element.online = 'false';
            if (element.active) {
              const diff = new Date().getTime() - new Date(element.active);
              if (diff <= 90000) {
                element.online = 'true';
                if (element?.status_info === 'Out Of Service' || element?.appStatus === 'false') {
                  element.online = 'oos';
                }
              }
            }
          });
          setIsLoading(true);
          setEmployees(res.data);
        }
      });
    }

    getAllMachines();

    return () => {
      isCancelled = true;
    };
  }, [reFresh]);

  const columns = [
    {
      title: 'update',
      field: 'update_app.update',
      type: 'boolean',
    },
    {
      title: 'ID',
      field: 'name',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main, fontFamily: 'monospace' }}>
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Description',
      field: 'description',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.description}
        </Typography>
      ),
    },
    {
      title: 'Model',
      field: 'model',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.model}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Belongs To',
      field: 'belongTo',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
          {rowData.belongTo}
        </Typography>
      ),
    },
    {
      title: 'Version',
      field: 'version',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.version || 'N/A'}
          size="small"
          sx={{
            fontWeight: 600,
            fontFamily: 'monospace',
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Free Disk',
      field: 'freedisk',
      editable: 'never',
      render: (rowData) => {
        if (rowData.freedisk) {
          const mb = parseInt(bytesToMegabytes(rowData.freedisk));
          const color = mb < 1000 ? theme.palette.error.main : theme.palette.success.main;
          return (
            <Chip
              label={`${mb} MB`}
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(color, 0.12),
                color: theme.palette.mode === 'dark' ? color : theme.palette.getContrastText(alpha(color, 0.12)),
                border: `1.5px solid ${alpha(color, 0.3)}`,
              }}
            />
          );
        }
        return '-';
      },
      customSort: (a, b) => {
        const c = a.freedisk === undefined || a.freedisk === null ? -Infinity : parseFloat(a.freedisk);
        const d = b.freedisk === undefined || b.freedisk === null ? -Infinity : parseFloat(b.freedisk);
        return c - d;
      },
    },
    {
      title: 'Temp℃',
      editable: 'never',
      render: (rowData) => {
        if (rowData.tempData?.curr_temp) {
          let currentTemp = parseInt(rowData.tempData?.curr_temp);
          let targetTemp = parseInt(rowData.tempData?.target_temp);
          let tempRange = parseInt(rowData.tempData?.temp_range);
          let finalString = ``;
          let statusColor = theme.palette.grey[400];

          if (rowData.tempData?.temp_control == '1') {
            finalString = `${currentTemp}-${targetTemp}(${tempRange})`;
            if (currentTemp >= targetTemp - tempRange && currentTemp <= targetTemp + tempRange) {
              statusColor = theme.palette.success.main;
            } else {
              statusColor = theme.palette.error.main;
            }
          } else {
            finalString = rowData.tempData?.curr_temp ? rowData.tempData?.curr_temp : '';
          }

          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StopRoundedIcon sx={{ color: statusColor, fontSize: 16 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {finalString}
              </Typography>
            </Box>
          );
        }
        return '-';
      },
    },
    {
      title: 'Status',
      field: 'online',
      editable: 'never',
      render: (rowData) => {
        let statusColor = theme.palette.grey[400];
        let statusText = 'Offline';

        if (rowData.online === 'true') {
          statusColor = theme.palette.success.main;
          statusText = 'Online';
        } else if (rowData.online === 'oos') {
          statusColor = theme.palette.error.main;
          statusText = 'Out of Service';
        }

        return (
          <Chip
            icon={<StopRoundedIcon sx={{ fontSize: 14, color: `${statusColor} !important` }} />}
            label={statusText}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(statusColor, 0.12),
              color: theme.palette.text.primary,
              border: `1.5px solid ${alpha(statusColor, 0.3)}`,
              '& .MuiChip-icon': {
                color: statusColor,
              },
            }}
          />
        );
      },
    },
    {
      title: 'In Service',
      field: 'oos',
      editable: 'never',
      render: (rowData) => (
        rowData.oos ? (
          <Chip
            label={rowData.oos}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.warning.main, 0.12),
              color: theme.palette.warning.dark,
              border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            }}
          />
        ) : null
      ),
    },
    {
      title: 'In Background',
      field: 'background',
      editable: 'never',
      render: (rowData) => (
        rowData.background ? (
          <Chip
            label={rowData.background}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.warning.main, 0.12),
              color: theme.palette.warning.dark,
              border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            }}
          />
        ) : null
      ),
    },
  ];

  // const updateTargetVersion = (id) => {
  //   console.log('option', id);
  //   console.log('targetV', targetV);

  //   let newArray = Object.values(id);
  //   newArray = newArray.map((e) => e.newData);
  //   newArray = newArray.map((e) => e._id);
  //   console.log(`newArray`, newArray);

  //   if (newArray.length > 0) {
  //     request({
  //       method: 'post',
  //       url: `/machines/updateTargetVersion`,
  //       data: {
  //         machineID: newArray,
  //         target_version: targetV,
  //       },
  //     })
  //       .then((res) => {
  //         console.log('res', res.data);
  //         Swal.fire({
  //           icon: 'success',
  //           title: 'Success',
  //           text: 'Target version updated successfully',
  //         });
  //         setRefresh(!reFresh);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: 'Failed to update target version',
  //         });
  //       });
  //   }
  // };

  const transferMachine = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this! Please delete the images under edit machine UI Modal before transfering",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, transfer it!',
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'post',
          url: `/machines/transferMachine`,
          data: {
            machineID: machine._id,
            clientID: client._id,
          },
        })
          .then((res) => {
            console.log('res', res.data);
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Machine transfered successfully',
            });
          })
          .catch((err) => {
            console.error(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to transfer machine',
            });
          });
      }
    });
  };

  const handleSubmit = () => {
    console.log('Submit', selectedRows);
    let newArray = [...selectedRows];
    newArray = newArray.map((e) => e._id);
    console.log(`newArray`, newArray);

    if (newArray.length > 0) {
      request({
        method: 'post',
        url: `/machines/updateTargetVersion`,
        data: {
          machineID: newArray,
          target_version: targetV,
        },
      })
        .then((res) => {
          console.log('res', res.data);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Target version updated successfully',
          });
          setRefresh(!reFresh);
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update target version',
          });
        });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.02
        )} 100%)`,
        pt: { xs: 0.8, sm: 1.2, md: 1.6, lg: 2 },
        px: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
        pb: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
      }}
    >
      {!isloading && <LoadingIcon />}

      {/* Header Section */}
      <ModernPageHeader
        title="All Machines"
        subtitle="Monitor and manage all machines across the system"
        icon={ComputerIcon}
      />

      {/* Machine Transfer Section for SuperAdmin */}
      {isSuperAdmin && (
        <Paper
          elevation={0}
          sx={{
            p: 4,
            mb: 4,
            borderRadius: 4,
            background: alpha(theme.palette.background.paper, 0.8),
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: 3,
              fontWeight: 700,
              color: theme.palette.text.primary,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <SwapHorizIcon />
            Transfer Machine
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'stretch', md: 'center' },
              gap: 3,
            }}
          >
            <Autocomplete
              options={employees}
              value={machine}
              onChange={(event, value) => setMachine(value)}
              isOptionEqualToValue={(option, value) => option.name === value.name}
              getOptionLabel={(option) => option.name + ' (' + option.description + ')'}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name + ' (' + option.description + ')'}
                </li>
              )}
              fullWidth
              sx={{ flex: 1 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Machine"
                  placeholder="Choose a machine to transfer"
                />
              )}
            />
            <Autocomplete
              options={users}
              value={client}
              onChange={(event, value) => setClient(value)}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.groupname + ' (' + option.groupCode + ')'}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.groupname + ' (' + option.groupCode + ')'}
                </li>
              )}
              fullWidth
              sx={{ flex: 1 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Target User/Group"
                  placeholder="Choose destination"
                />
              )}
            />
            <Button
              onClick={transferMachine}
              type="submit"
              variant="contained"
              disabled={!machine || !client}
              startIcon={<SwapHorizIcon />}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.5,
                minWidth: { xs: '100%', md: 'auto' },
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                '&.Mui-disabled': {
                  background: alpha(theme.palette.grey[400], 0.3),
                  color: alpha(theme.palette.text.disabled, 0.5),
                  boxShadow: 'none',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Transfer
            </Button>
          </Box>
        </Paper>
      )}

      {/* Modern Table */}
      <ModernTable
        onRowsPerPageChange={setPagination}
        columns={columns}
        data={employees}
        onSelectionChange={(rows) => setSelectedRows(rows)}
        options={{
          selection: false,
          actionsColumnIndex: -1,
          pageSize: parseInt(pagination),
          pageSizeOptions: [20, 50, 100],
        }}
      />

      {/* Back Button */}
      <Box sx={{ mt: 3 }}>
        <BackButton />
      </Box>
    </Box>
  );
}
